'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.store = undefined;
exports.configureStore = configureStore;

var _redux = require('redux');

var _middleware = require('./middleware');

var _reducers = require('./reducers');

function configureStore() {
  return (0, _redux.createStore)(_reducers.reducers, _middleware.middleware);
}

var store = exports.store = configureStore();